import React from 'react'
import { FormattedMessage } from 'react-intl'

import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import Caption from 'LuxKit/Typography/Caption'

interface Props {
  startLocation?: string | null
  typeOfExperience?: string
  size?: 'small' | 'medium' | 'large'
}

function BookmarkLocationWithTypeOfExperience({
  startLocation,
  typeOfExperience,
  size = 'large',
}: Props) {
  const locationLabel = typeOfExperience ? <FormattedMessage
    id="oaZgTg1lDH"
    defaultMessage="{startLocation}<experienceText> · {typeOfExperience}</experienceText>"
    description="Bookmark card location with styled experience type suffix"
    values={{
      startLocation,
      typeOfExperience,
      experienceText: (chunks) => <Caption as="span" variant={size} colour="neutral-two">{chunks}</Caption>,
    }}
  /> : startLocation

  return (
    <CaptionTextBlock variant={size} lineClamp={2}>
      {locationLabel}
    </CaptionTextBlock>
  )
}

export default BookmarkLocationWithTypeOfExperience
